<template>
  <div class="width-a">
    <div class="navigate"><span>首页 > </span><span>精英采访 > </span><span>{{interviewsDetail.interviewTitle}} > </span>
    </div>
    <h1 class="title">{{interviewsDetail.interviewTitle}}</h1>
    <div class="menu">
      <video v-if="interviewsDetail.fileUrl" class="img-a" ref="localVideo" :src="interviewsDetail.fileUrl | fileFilter"
        controls></video>
      <div class="content">
        <div class="cover">
          <img :src="interviewsDetail.imgUrl | fileFilter" alt="">
        </div>
        <span class="txt-a">{{interviewsDetail.interviewTitle}}</span>
        <p class="txt-b">{{interviewsDetail.introduce}}</p>
      </div>
    </div>
    <div style="height: 64px"></div>
  </div>
</template>

<script>
  import CommonFilters from "@/mixins/CommonFilters";
  import HttpConnectionC from "@/utils/HttpConnectionC";
  export default {
    name: "InterviewsDetail",
    mixins: [CommonFilters],
    data () {
      return {
        interviewsDetail: {},
        resetTime: 0, // 拖动后重置播放时间
        curTime: 0,  // 当前播放时间
      }
    },
    mounted () {
      let that = this;
      let _id = that.$route.query.interviewId;
      HttpConnectionC.get(`/homepage/readInterview/${_id}`).then(function (response) {
        that.interviewsDetail = response.data;
      });
    },
    methods: {
      // // 禁止快进视频
      // fastForward () {
      //   let that = this;
      //   var vido = that.$refs.localVideo
      //   setInterval(() => {
      //     vido.playbackRate = 1;
      //   }, 1000);
      //   let vd = that.$refs.localVideo; //获取video对象
      //   let getCurTime = localStorage.getItem('remTime'); //获取本地存储
      //   if (getCurTime > 0.1) {
      //     that.curTime = getCurTime;
      //     that.resetTime = getCurTime;
      //     vd.addEventListener('play', function () {
      //       setTimeout(function () {
      //         vd.currentTime = getCurTime;
      //         setInterval(timer, 100)
      //       }, 2000)
      //     })
      //   } else {
      //     vd.play();
      //     setInterval(timer, 100)
      //   }

      //   // 定时器
      //   function timer () {
      //     that.curTime = vd.currentTime;
      //     let apartTime = that.curTime - that.resetTime;
      //     if (apartTime > 2) {
      //       vd.currentTime = that.resetTime;
      //     } else {
      //       that.resetTime = that.curTime;
      //     }
      //     that.curTime = that.curTime;
      //   }
      //   vd.addEventListener('pause', function () {
      //     localStorage.setItem('remTime', that.curTime);
      //   })
      // }
    },
  };
</script>

<style scoped lang="scss">
  .navigate {
    font-size: 14px;
    font-weight: 400;
    color: #4d4d4d;
  }

  .title {
    font-size: 32px;
    font-weight: 400;
    color: #000000;
    margin: 8px 0px 20px 0px;
  }

  .img-a {
    width: 1180px;
    height: 575px;
    margin: 20px 0;
  }

  .content {
    width: 100%;
    background-color: #f2f2f2;
    padding: 32px 60px;

    p {
      line-height: 1.7;
      letter-spacing: 1.2;
    }
  }

  .txt-a {
    font-size: 20px;
    font-weight: 400;
    color: #000000;
  }

  .txt-b {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: #333333;
    margin: 24px 0px 0px 0px;
  }

  .menu {
    width: 1180px;
    display: flex;
    flex-wrap: wrap;
  }

  .cover {
    width: 35%;
    height: 270px;
    float: right;
    margin: 50px 30px 30px 30px;

    img {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
      margin: auto;
    }
  }
</style>